import { render, staticRenderFns } from "./WallPost.vue?vue&type=template&id=5d47b246&scoped=true"
import script from "./WallPost.vue?vue&type=script&lang=js"
export * from "./WallPost.vue?vue&type=script&lang=js"
import style0 from "./WallPost.vue?vue&type=style&index=0&id=5d47b246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d47b246",
  null
  
)

export default component.exports